/* eslint-disable no-console */
export default {
  // We call this specifically "CREATE", because here only the new activity is created
  // The actual recording (watching the GPS, tracking the route...) is not
  // done via VUEX, but only in "newActivity.vue" and later saved.
  CREATE_NEW_ACTIVITY (state, payload) {
    state.newActivity = payload
    state.newActivityStatus = 'started'
  },
  FINISH_NEW_ACTIVITY (state, payload) {
    state.newActivityStatus = 'finished'
  },
  PAUSE_NEW_ACTIVITY (state, payload) {
    state.recording = false
    state.newActivityStatus = 'paused'
  },
  RESUME_NEW_ACTIVITY (state, payload) {
    state.recording = true
    state.newActivityStatus = 'resumed'
  },
  SET_RECORDING (state, payload) {
    state.recording = payload
  },
  //
  // ----- Temporary coordinates
  //          will be merged into final newActivity obj
  //          once the user decides to save the tracked route
  //
  SAVE_TMP_COORDS (state, payload) {
    state.tmpCoords.push(payload[0])
    state.tmpCoordsExt.push(payload[1])
  },
  CLEAR_TMP_COORDS (state) {
    state.tmpCoords = []
    state.tmpCoordsExt = []
  },
  SET_TOTAL_DISTANCE (state, obj) {
    state.totalDistance = obj
  },
  SET_SPEED (state, int) {
    state.speed = int
  },
  SET_TOTAL_STEPS (state, obj) {
    state.totalSteps = obj
  }
}
